import { render } from "./WaveList.vue?vue&type=template&id=40d614b6&scoped=true"
import script from "./WaveList.vue?vue&type=script&lang=js"
export * from "./WaveList.vue?vue&type=script&lang=js"

import "./WaveList.vue?vue&type=style&index=0&id=40d614b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40d614b6"]])

export default __exports__